import React, { ReactNode } from "react";
import { Button, ChevronEndMediumIcon, Flex, Loader, Text } from "@fluentui/react-northstar";
import styles from "./taskDetailsNodeItem.module.scss";
import classNames from "classnames";
import { TeamsTextWeight } from "shared/types/TeamsTextWeight";

interface TaskDetailsNodeItemProps {
    label: string;
    primaryTextWeight?: TeamsTextWeight;
    isMobile?: boolean;
    additionalClassName?: string;
    children: ReactNode;
    isLoading: boolean;
}

const TaskDetailsNodeItem: React.FC<TaskDetailsNodeItemProps> = (props: TaskDetailsNodeItemProps) => {
    return (
        <Flex className={classNames(props.additionalClassName, props.isMobile && styles.wrapper)}>
            <Flex className={styles.label}>
                <Text content={props.label} weight={props.primaryTextWeight ?? "semibold"} />
            </Flex>
            <Flex column={!props.isMobile} space="between">
                {props.isLoading ? <Loader className={styles.inlineLoader} size="smallest" inline /> : props.children}
            </Flex>
        </Flex>
    );
};

export default TaskDetailsNodeItem;
